module.exports = __webpack_public_path__ + "static/media/partner05.8fcf0410.png";